import { Resizer } from "@/services/imageFileResizer";

interface ResizeAvatarImageResult {
  originalImg: Blob;
  compressedImg: Blob;
}

/**
 * Resize avatar image
 *
 * @param image
 * @returns both big and small resized avatar images
 */
export async function resizeAvatarImage(image: Blob): Promise<ResizeAvatarImageResult> {
  const originalImg = (await Resizer.createResizedImage(image, 600, 600, "jpeg", 50, 0, "blob")) as Blob;
  const compressedImg = (await Resizer.createResizedImage(image, 96, 96, "jpeg", 50, 0, "blob")) as Blob;

  return { originalImg, compressedImg };
}
